<button
    (click)="clicked.emit()"
    [class.mona-on-screen-keypad-button--submit]="isSubmit"
    [type]="isSubmit ? 'submit' : 'button'"
    class="mona-on-screen-keypad-button"
    mat-flat-button
>
    <ng-content></ng-content>
</button>
